export default "__VITE_ASSET__94b0e4df__"